<template>
  <b-card title="Transaksi">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Cari</label>
          <b-form-input
            v-model="searchTermProfile"
            placeholder="Search"
            name="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <div v-if="!rows" class="text-center">
        <b-spinner label="Tunggu..."></b-spinner>
    </div>
    <vue-good-table
      v-if="rows"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTermProfile }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Row number -->
        <span
          v-if="props.column.field === 'row_number'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ (props.row.originalIndex + 1) }}</span>
        </span>

        <span v-else-if="props.column.field === 'total_price_amount'">
          <span class="text-nowrap">{{ formatPrice(props.row.total_price) }}</span>
          </div>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'transaction_status'">
          <b-badge :variant="statusVariant(props.row.transaction_status == 1)">
            {{ getStatusLabel(props.row.transaction_status)  }}
          </b-badge>
          </div>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Data 1 hingga
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> dari {{ props.total }} </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>

</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BForm, BButton, BSpinner, BBadge
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BForm,
    BButton,
    BSpinner,
    BBadge
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStatusLabel(status) {
      if(status == 1) {
        return 'Berhasil'
      }
      else
      if(status == 0) {
        return 'Gagal'
      }
      else
      if(status == 2) {
        return 'Menunggu Pembayaran'
      }
      else {
        return ''
      }
    },
    formatPrice(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    statusVariant(status) {
      return status ? 'light-success' : 'light-danger'
    },
  },
  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
        {
            label: 'No',
            field: 'row_number',
        },
        {
          label: 'Kode Transaksi',
          field: 'transaction_number',
        },
        {
          label: 'Metode Pembayaran',
          field: 'payment_method',
        },
        {
          label: 'Ref. Pembayaran',
          field: 'payment_referal_number',
        },
        {
          label: 'Nilai',
          field: 'total_price_amount',
        },
        {
          label: 'Status',
          field: 'transaction_status',
        },
        {
          label: 'Tgl Transaksi',
          field: 'transaction_date',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd-MM-yyyy',
        }
      ],
      searchTermProfile: '',
    }
  },
}
</script>